import React, { createContext, useState, useEffect, useContext } from "react";
import io from "socket.io-client";

const SocketContext = createContext();

const SERVER_URL =
  "https://socket-server-micro-service-hifck5sj6a-uk.a.run.app";

// const SERVER_URL =
//   "http://localhost:5010";

const userName = "Robert-" + Math.floor(Math.random() * 100000);
const password = "x";

export const useCustomSocket = () => {
  return useContext(SocketContext);
};

export const SocketProvider = ({ children }) => {
  const [socketState, setSocketState] = useState({
    socket: undefined,
    isConnected: false,
    sessionId: "",
    userName,
  });

  const subscribeToEvent = (event, callback) => {
    if (socketState.socket) {
      console.log("subscribing to event", event);
      socketState.socket.on(event, callback);
    }
  };

  const sendMessage = (event, message) => {
    if (socketState.socket) {
      console.log("sending message", message);
      socketState.socket.emit(event, message, socketState?.sessionId);
    }
  };

  const joinSession = (sessionId) => {
    if (socketState.socket) {
      socketState.socket.emit("join-session", sessionId);
      setSocketState((prevState) => ({
        ...prevState,
        sessionId: sessionId,
      }));
    }
  };

  const initiateSocket = (sessionId = "") => {
    const newSocket = io(SERVER_URL, {
      auth: {
        userName,
        password,
      },
      transports: ["websocket", "polling"],
    });
    if (sessionId) {
      newSocket.emit("join-session", sessionId);
    }
    setSocketState((prevState) => ({
      socket: newSocket,
      isConnected: true,
      sessionId: sessionId,
    }));
  };

  const createSession = (data = {}) => {
    console.log("Creating session with data:", data);
    const newSocket = io(SERVER_URL, {
      auth: {
        userName,
        password,
      },
      forceNew: true,
      transports: ["websocket", "polling"],
    });
    console.log("newSocket", newSocket);
    newSocket.emit("create-session", data);
    setSocketState((prevState) => ({
      ...prevState,
      socket: newSocket,
      isConnected: true,
      sessionId: data?.phone,
    }));
  };

  const disconnectSocket = () => {
    if (socketState.socket) {
      socketState.socket.disconnect();
      setSocketState((prevState) => ({
        socket: undefined,
        isConnected: false,
        sessionId: "",
      }));
    }
  };

  return (
    <SocketContext.Provider
      value={{
        socketState,
        subscribeToEvent,
        sendMessage,
        joinSession,
        initiateSocket,
        disconnectSocket,
        createSession,
      }}
    >
      {children}
    </SocketContext.Provider>
  );
};
